import React, { useState, useEffect } from 'react';
import { analyticsAPI } from '../services/api';
import { format } from 'date-fns';
import ChatDetailModal from '../components/ChatDetailModal';

const Chats = () => {
  const [chats, setChats] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 20, total: 0, totalPages: 0 });
  const [filters, setFilters] = useState({
    product: '',
    interface_type: '',
    date_from: '',
    date_to: '',
    search: ''
  });
  const [selectedChat, setSelectedChat] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadChats();
  }, [pagination.page, filters]);

  const loadChats = async () => {
    setLoading(true);
    try {
      const params = {
        page: pagination.page,
        limit: pagination.limit,
        ...filters
      };
      
      const response = await analyticsAPI.getChats(params);
      setChats(response.data.data);
      setPagination(response.data.pagination);
    } catch (error) {
      console.error('Error loading chats:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
    setPagination(prev => ({ ...prev, page: 1 }));
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 4
    }).format(value || 0);
  };

  const formatNumber = (value) => {
    return new Intl.NumberFormat('it-IT').format(value || 0);
  };

  return (
    <div>
      <div className="header">
        <h1>Conversazioni</h1>
      </div>

      {/* Filtri */}
      <div className="chart-container" style={{ marginBottom: '20px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
          <div className="form-group">
            <label>Cerca Session ID</label>
            <input
              type="text"
              value={filters.search}
              onChange={(e) => handleFilterChange('search', e.target.value)}
              placeholder="Cerca..."
            />
          </div>
          <div className="form-group">
            <label>Prodotto</label>
            <input
              type="text"
              value={filters.product}
              onChange={(e) => handleFilterChange('product', e.target.value)}
              placeholder="Nome prodotto"
            />
          </div>
          <div className="form-group">
            <label>Interfaccia</label>
            <select
              value={filters.interface_type}
              onChange={(e) => handleFilterChange('interface_type', e.target.value)}
            >
              <option value="">Tutte</option>
              <option value="web">Web</option>
              <option value="cli">CLI</option>
            </select>
          </div>
          <div className="form-group">
            <label>Data Da</label>
            <input
              type="date"
              value={filters.date_from}
              onChange={(e) => handleFilterChange('date_from', e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Data A</label>
            <input
              type="date"
              value={filters.date_to}
              onChange={(e) => handleFilterChange('date_to', e.target.value)}
            />
          </div>
        </div>
      </div>

      {/* Tabella chat */}
      <div className="table-container">
        {loading ? (
          <div className="loading">Caricamento...</div>
        ) : (
          <>
            <table className="table">
              <thead>
                <tr>
                  <th>Session ID</th>
                  <th>Prodotto</th>
                  <th>Interfaccia</th>
                  <th>Messaggi</th>
                  <th>Token</th>
                  <th>Costo</th>
                  <th>Risparmio</th>
                  <th>Data</th>
                  <th>Azioni</th>
                </tr>
              </thead>
              <tbody>
                {chats.map((chat) => (
                  <tr key={chat.chat_id}>
                    <td>
                      <code style={{ fontSize: '12px' }}>
                        {chat.session_id.substring(0, 8)}...
                      </code>
                    </td>
                    <td>{chat.product_name}</td>
                    <td>
                      <span style={{
                        padding: '3px 8px',
                        borderRadius: '3px',
                        fontSize: '12px',
                        background: chat.interface_type === 'web' ? '#e3f2fd' : '#f3e5f5',
                        color: chat.interface_type === 'web' ? '#1976d2' : '#7b1fa2'
                      }}>
                        {chat.interface_type}
                      </span>
                    </td>
                    <td>{formatNumber(chat.total_messages)}</td>
                    <td>{formatNumber(chat.total_tokens)}</td>
                    <td>{formatCurrency(chat.total_cost_usd)}</td>
                    <td style={{ color: '#28a745' }}>
                      {formatCurrency(chat.total_savings_usd)}
                    </td>
                    <td>{format(new Date(chat.created_at), 'dd/MM/yyyy HH:mm')}</td>
                    <td>
                      <button
                        className="btn btn-primary"
                        style={{ padding: '5px 10px', fontSize: '12px' }}
                        onClick={() => setSelectedChat(chat.chat_id)}
                      >
                        Dettagli
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Paginazione */}
            <div className="pagination">
              <button
                onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))}
                disabled={pagination.page === 1}
              >
                Precedente
              </button>
              <span>
                Pagina {pagination.page} di {pagination.totalPages} ({formatNumber(pagination.total)} totali)
              </span>
              <button
                onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))}
                disabled={pagination.page === pagination.totalPages}
              >
                Successiva
              </button>
            </div>
          </>
        )}
      </div>

      {/* Modal dettagli chat */}
      {selectedChat && (
        <ChatDetailModal
          chatId={selectedChat}
          onClose={() => setSelectedChat(null)}
        />
      )}
    </div>
  );
};

export default Chats;

